<template>
  <div class="opage">
    <div>
      <!-- 配送单列表 -->
      <baseBreadcrumb :page="$t('message.porderList')" :menu="$t('message.orderManagement')"></baseBreadcrumb>
      <!-- 搜索 -->
      <div class="body">
        <!-- 状态筛选 -->
        <div class="tabs">
          <el-tabs v-model="statusRange" type="card" @tab-click="porderList">
            <el-tab-pane :label="item.name + `(${item.count})`" :name="item.statusRange" v-for="(item, index) in tabs"
              :key="index">
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="search">
          <div class="row">
            <!-- 请输入完整配送单号 -->
            <div class="item">
              <el-input v-model="datas.porder_sn" placeholder="注文書番号" clearable onfocus="this.select()">
              </el-input>
            </div>
            <!-- 开始日期-->
            <div class="item">
              <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
                type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
              </el-date-picker>
            </div>
            <!--  结束日期-->
            <div class="item">
              <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
                default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
              </el-date-picker>
            </div>
            <!-- 搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
            <!-- 重置 -->
            <el-button @click="reset">
              {{ $t("message.reset") }}
            </el-button>
          </div>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!-- 配送单号 -->
            <li>{{ $t("message.deliveryNoteNumber") }}</li>
            <!-- 提出日期 -->
            <li>{{ $t("message.proposedDate") }}</li>
            <!-- 付款日期 -->
            <li>{{ $t("message.paymentDate") }}</li>
            <!-- 发货日期 -->
            <li>{{ $t("message.shipDate") }}</li>
            <!-- 导出excel -->
            <li>{{ $t("message.exportExcel") }}</li>
            <!-- 配送单状态 -->
            <li>{{ $t("message.porderStatus") }}</li>
            <!-- 操作 -->
            <li>{{ $t("message.operation") }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">{{ index + 1 }}</li>
            <!-- 配送单号 -->
            <li> <router-link :to="'/porderDetail?porder_sn=' + item.porder_sn" target="_blank" class="a-link"
                v-if="item.status != 10">{{
                  item.porder_sn
                }}</router-link>
              <router-link :to="'/deliveryPreview?porder_sn=' + item.porder_sn" target="_blank" class="a-link" v-else>{{
                item.porder_sn
              }}</router-link>
              <i class="el-icon-copy-document" @click="copy(item.porder_sn)"></i>
            </li>
            <!-- 提出日期 -->
            <li>{{ item.created_at }}</li>
            <!-- 付款日期 -->
            <li>{{ item.porder_time_node ? item.porder_time_node.datetime_pay_confirm : '' }}</li>
            <!-- 发货日期 -->
            <li>{{ item.porder_time_node ? item.porder_time_node.datetime_delivery : '' }}</li>
            <!-- 导出excel -->
            <li>
              <!-- 正式配送单才可以导出EXCEL -->
              <!--2023/2/24 这个地方还没有接口，先空着 -->
              <span v-if="item.status != 10">
                <a :href="baseURL + '/download.porderDetailDownload?porder_sn=' + item.porder_sn" target="_blank"
                  rel="noopener noreferrer">
                  <i class="el-icon-download">
                  </i>
                </a>
              </span>

            </li>
            <!-- 配送单状态 -->
            <li>{{ item.status_name }}</li>
            <!-- 操作 -->
            <li>
              <div>
                <!-- 付款 -->
                <p style="margin-bottom: 5px" v-if="item.status == 30 && isAuth(457) && detail.is_pay_authorized"
                  @click="$router.push({
                    name: 'payPage',
                    query: {
                      userID: $route.query.userID,
                      porder_sn: item.porder_sn
                    }
                  })">
                  <el-button size="small" type="primary" class="primary">{{
                    $t("message.payments")
                  }}</el-button>
                </p>
                <!-- 签收 -->
                <p style="margin-bottom: 5px" v-if="item.status == 60 && isAuth(459)">
                  <el-button @click="porderClientReceive(item)" size="small" type="primary" class="primary">{{
                    $t("message.signFor") }}</el-button>
                </p>
                <!-- 删除 -->
                <p v-if="item.status == 10 && isAuth(458)">
                  <el-button size="small" type="primary" class="fr" @click="deleteData(item)">{{ $t("message.delete")
                    }}</el-button>
                </p>
              </div>
            </li>
          </ul>
          <div v-if="tableData == false" class="No_data">暂无数据</div>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="datas.page" :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      statusRange: "[]", //statusRange规则由split改成stringify,所以设置 "[]"为初始值
      tabs: [],
      num: 0,
      datas: {
        user_id: this.$route.query.userID,
      },
      tableData: [],
      total: 0,
      checked: false,
      checkNum: 0, // 已选商品番数
      chioseIdArr: [],
      detail: {},
    };
  },
  component: {},
  created() {
    this.$api.clienteleApi.clientDetail({ user_id: this.datas.user_id }).then(res => {
      this.detail = res.data
    })
    this.porderTabList();
    this.porderList();
  },
  methods: {
    porderClientReceive(item) {
      // 确认签收配送单？
      this.$confirm(this.$t("message.isClientReceive"), {
        confirmButtonText: this.$t("message.ok"),
        cancelButtonText: this.$t("message.cancel"),
        type: "warning",
      }).then(() => {
        this.$api.clienteleApi
          .porderClientReceive({
            user_id: this.$route.query.userID,
            porder_sn: item.porder_sn,
          })
          .then((res) => {
            if (res.code != 0) return this.$message.error(res.data.msg);
            //   签收成功
            this.$message({
              type: "success",
              message: this.$t("message.theDeletionWasSuccessful"),
            });
            this.porderList();
          });
      });
    },
    deleteData(item) {
      // 是否确定删除？
      this.$confirm(this.$t("message.areYouSureToDelete"), {
        confirmButtonText: this.$t("message.ok"),
        cancelButtonText: this.$t("message.cancel"),
        type: "warning",
      })
        .then(() => {
          this.$api.clienteleApi
            .porderDelete({
              user_id: this.$route.query.userID,
              porder_sn: item.porder_sn,
            })
            .then((res) => {
              if (res.code != 0) return this.$message.error(res.data.msg);
              //   删除成功
              this.$message({
                type: "success",
                message: this.$t("message.theDeletionWasSuccessful"),
              });
              this.porderList();
            });
        })
        .catch(() => {
          //this.$message({
          //type: 'info',
          //message: '已取消删除'
          //});
        });
    },
    // 获取表格tab数据
    porderTabList() {
      this.$api.clienteleApi
        .porderTabList({
          user_id: this.$route.query.userID,
        })
        .then((res) => {
          if (res.code != 0) return this.$message.error(res.data.msg);
          res.data.unshift(res.data.splice(res.data.length - 1, res.data.length - 1)[0])  //接口返回的全部放到最后面了，把它排到前面
          res.data.forEach((item) => {
            item.statusRange = JSON.stringify(item.statusRange);
          });
          this.tabs = res.data;
        });
    },
    // 重置
    reset() {
      this.datas = {
        user_id: this.$route.query.userID,
        statusRange: [],
      };
      this.porderList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.porderList();
    },
    // 获取配送单列表
    porderList() {
      if (this.statusRange) {
        this.datas.statusRange = JSON.parse(this.statusRange);
      } else {
        delete this.datas.statusRange;
      }
      this.$api.clienteleApi.porderList(this.datas).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.porderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.porderList();
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin: 24px 0;
  position: relative;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;
}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.table {
  font-size: 14px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flex15 {
    flex: 1.5;
  }

  .important {
    background-color: #e0e7f7;
    max-height: 100px;
    overflow: hidden;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    height: 100px;

    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}

.el-icon-download {
  font-size: 25px;
  color: #B4272D;
  cursor: pointer
}
</style>
